require('./brokerContributionInvestmentFundStep1.scss');

const PropTypes = require('prop-types');

// @ vendor
const React = require('react');

// @ components
const OKSelect = require('components/commons/OKSelect/OKSelect');
const { OKButton } = require('components/commons/OKButton/OKButton');
const DatePickerCustom = require('components/datePickerCustom/datePickerCustom');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
// @ commons
const { AmountInput } = require('commonsComponents/amountInput');

// @ helpers
const { FormattedText, formatText, getLanguage } = require('core/i18n').i18n;
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');
const { recordPage } = require('utilities/tagging.js')
// @ constants
const { HYPHEN } = require('constants/index');
const {
  DATE_PICKER_CUSTOM_PLACEHOLDER,
  DATE_PICKER_CUSTOM_LOCALE,
  DATE_PICKER_CUSTOM_DATE_FORMAT,
} = require('constants/commonsComponents');
const BrokerInterestModal = require('../brokerInterestModal/brokerInterestModal');
const language = getLanguage();

class BrokerContributionInvestmentFundStep1 extends React.Component {
  constructor(props) {
    super(props);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.handlePeriodicityChange = this.handlePeriodicityChange.bind(this);
    this.handleClickDeleteAmount = this.handleClickDeleteAmount.bind(this);
    this.handleAmountBlur = this.handleAmountBlur.bind(this);
    this.handleAmountChange = this.handleAmountChange.bind(this);
    this.handleDatePickerError = this.handleDatePickerError.bind(this);
    this.handleToggleModal = this.handleToggleModal.bind(this);
    this.state = {
      showInterestModal: false,
    };
  }

  componentDidMount() {
    const { isin } = this.props;
    const customData = {
      event_name: "step_investment_details",
      pageName: "/buyFundsPeriodicContribution/step1/investmentDetails",
      sectionFamily: "wealth",
      sectionCategory: "products",
      sectionName: "funds",
      serviceType: "productContracting",
      interactionType: "funnel",
      processType: "buyFundsPeriodicContribution",
      processStep: "step1",
      processDetail: "investmentDetails",
      productName: isin
      }
      recordPage(customData);
    this.props.onStepChange('step 1');
  }

  handleDateChange(date) {
    this.props.setValidityDate(date);
  }

  handlePeriodicityChange(value) {
    this.props.setPeriodicity(value);
  }
  handleClickDeleteAmount() {
    this.props.setAmount(0);
  }
  handleAmountBlur(value) {
    this.props.setAmount(value);
  }
  handleAmountChange(value) {
      this.props.setAmount(value);
  }

  handleDatePickerError(error) {
    this.props.setDatePickerError(error);
  }
  handleToggleModal = () => {
    this.setState({ showInterestModal: !this.state.showInterestModal });
  };

  buildRemoveIcon() {
    return (
      <span
        onClick={() => this.handleClickDeleteAmount()}
        className="contribution-investment-step1__icon-amount"
      >
        <i class="custom-notification__icon icon-agregar"></i>
      </span>
    );
  }


  buildInput() {
    const { amount, amountErrorState, amountErrorMsg, customMinimumPurchaseAmount } = this.props;
    const currency = customMinimumPurchaseAmount.get('currency');
    const minimunAmount = customMinimumPurchaseAmount.get('additionalSubscriptionAmount');
    const plainAmountObject = getPlainAmountObject({
        amount: minimunAmount,
        currency,
    });
    const removeIcon = amount !== 0 ? this.buildRemoveIcon() : null;
    const onlineSymbolObject = currency && minimunAmount ?
                (<OneLineSymbolAmount
                    positiveAmount
                    amountObject={plainAmountObject}
                    language={language}
                    amountObjectFormatted={formatAmountObject(plainAmountObject, true)} />)
                : HYPHEN;

    return (
      <div className="contribution-investment-step1__input-container">
        <FormattedText
            value="brokerContributionFundStep1-amount2"
            className="contribution-investment-step1__associated-cc-amount"
            injectedStrings={[`(${currency.toUpperCase()})`]}
        />
        <div className="contribution-investment-step1__amount-box">
          <div
          >
              <AmountInput
                amount={amount}
                callback={this.handleAmountBlur}
                onChange={this.handleAmountChange}
                error={amountErrorState}
                errorMsg={amountErrorMsg}
                hideFocusZero={true}
                showBlurZero={true}
                language={language}
              />
          </div>
          {removeIcon}
        </div>
        <div className="contribution-investment-step1__associated-cc-minimal">
          <FormattedText
            value={'brokerContributionFundStep1-miniumAmountText1'}
          />
          {onlineSymbolObject}
          <FormattedText
            value={'brokerContributionFundStep1-miniumAmountText2'}
          />
        </div>
      </div>
    );
  }

  getSelectionOptions() {
    const { periodicityOptions } = this.props;
    return periodicityOptions.toJS().map((option) => {
        const label = formatText(option.label);
        return {
            label,
            value: option.value,
        };
    });
  }

  createMonthlyDropdown() {
    const { periodicityError, periodicityValue, periodicityErrorMsg } = this.props;

    return (
      <div className={`contribution-investment-step1__select`}>
        <OKSelect
          label={formatText('brokerContributionFundStep1-priodicityLabel')}
          onChange={this.handlePeriodicityChange}
          options={this.getSelectionOptions()}
          value={periodicityValue}
          autosize={false}
          placeholder={''}
          errorState={periodicityError}
          errorMessage={periodicityErrorMsg}
          searchable={false}
        />
      </div>
    );
  }

  createDatePicker() {
    const { selectedDate, minDate, datePickerDisabled } = this.props;

    return (
      <span className="contribution-investment-step1__date-picker">
        <DatePickerCustom
          callback={this.handleDateChange}
          selectedDate={selectedDate}
          label={formatText('brokerContributionFundStep1-datePickerLabel')}
          placeholder={formatText(DATE_PICKER_CUSTOM_PLACEHOLDER)}
          locale={formatText(DATE_PICKER_CUSTOM_LOCALE)}
          dateFormat={formatText(DATE_PICKER_CUSTOM_DATE_FORMAT)}
          disabled={datePickerDisabled}
          minDate={minDate}
          startDate={minDate}
          newSelectedDate={selectedDate}
          callbackError={this.handleDatePickerError}
        />
      </span>
    );
  }

  render() {
    const title = formatText('brokerContributionFundStep1-title');

    const inputs = (
      <div className="contribution-investment-step1__periodicly-box">
        {this.buildInput()}
        {this.createMonthlyDropdown()}
        {this.createDatePicker()}
      </div>
    );

    return (
      <div className="contribution-investment-step1">
        <header className="contribution-investment-step1__header">
          <h2 className="contribution-investment-step1__title">
            {title}
          </h2>
          <FormattedText value="brokerContributionFundStep1-descriptionFirst"/>
          <OKButton modifier="link-emphasize" onClick={this.handleToggleModal}>
            {formatText('brokerContributionFundStep1-descriptionLink')}
          </OKButton>
          <FormattedText value="brokerContributionFundStep1-descriptionSecond"/>
        </header>
        {inputs}
        <BrokerInterestModal
          isOpen={this.state.showInterestModal}
          onCloseCallback={this.handleToggleModal}
        />
      </div>
    );
  }
}

BrokerContributionInvestmentFundStep1.propTypes = {
  isin: PropTypes.string.isRequired,
  onStepChange: PropTypes.func,

  customMinimumPurchaseAmount: PropTypes.number,
  amount: PropTypes.number,
  amountErrorState: PropTypes.bool,
  errorMsg: PropTypes.string,
  setAmount: PropTypes.func,
  onClickDeleteAmount: PropTypes.func.isRequired,

  periodicityError: PropTypes.bool,
  periodicityErrorMsg: PropTypes.string,
  periodicityValue: PropTypes.string,
  periodicityOptions: PropTypes.array,
  setPeriodicity: PropTypes.func.isRequired,

  setValidityDate: PropTypes.func.isRequired,
  selectedDate: PropTypes.object,
  minDate: PropTypes.object,
  setDatePickerError: PropTypes.func,
  datePickerDisabled: PropTypes.bool,

};

module.exports.BrokerContributionInvestmentFundStep1 = BrokerContributionInvestmentFundStep1;

